import r from "react";

function i() {
  return function () {
    return {
      key: "plugin-renderer-basic",
      render: function render(_ref) {
        var t = _ref.stack;
        return r.createElement(r.Fragment, null, t.render().activities.filter(function (e) {
          return e.transitionState !== "exit-done";
        }).map(function (e) {
          return r.createElement(r.Fragment, {
            key: e.key
          }, e.render());
        }));
      }
    };
  };
}

export { i as basicRendererPlugin };